<template>
  <div class="vuestic-collapse">

    <div class="vuestic-collapse__header" :class="{
      'vuestic-collapse__header--no-header': noHeader,
    }" @click="onHeaderClick()">
      <template v-if="noHeader">
        <slot name="header" />
      </template>
      <button v-else class="vuestic-collapse__header__button btn-lg collapse-btn">
        <slot name="header" />
        <i :class="{ 'fa fa-angle-up': iconUp, 'fa fa-angle-down': !iconUp }"
          style="padding-right: 5px; color: black;"></i>
      </button>
    </div>

    <div class="vuestic-collapse__body collapse-content" ref="collapseBody">
      <slot name="body" />
    </div>

  </div>
</template>

<script>
export default {
  name: 'alunoCollapse',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    noHeader: Boolean,
  },
  inject: {
    accordion: {
      default: () => ({
        onChildChange: () => { },
      }),
    },
  },
  data() {
    return {
      show: this.value,
      iconUp: false,
    }
  },
  watch: {
    show(show) {
      if (show) {
        this.expand()
        this.iconUp = true
      } else {
        this.collapse()
        this.iconUp = false
      }
    },
  },
  methods: {
    expand() {
      const bodyContent = this.$refs.collapseBody
      bodyContent.style.height = this.$slots.body[0].elm.clientHeight + 'px'

      this.show = true
    },
    collapse() {
      const bodyContent = this.$refs.collapseBody
      bodyContent.style.height = 0

      this.show = false
    },
    onHeaderClick() {
      this.toggle()
      this.accordion.onChildChange(this, this.show)
      this.iconUp = !this.iconUp
    },
    // Public
    toggle() {
      this.show ? this.collapse() : this.expand()
    },
  },
}
</script>

<style lang="scss">
.vuestic-collapse {
  &+& {
    margin-top: 8px;
  }

  &__body {
    height: 0;
    transition: height 1s;
    margin-top: 20px;
    background: white;
    overflow: hidden;
    padding-left: 20px;
    padding-right: 20px;
  }

  &__header {
    &__button {
      width: 100%;
      padding-left: 1.5rem;
      border-radius: 0;
      background-color: white;
      text-align: left;
      border: none;
      outline: none;
    }

    &--no-header {
      margin-bottom: 1rem;
    }
  }

  .vuestic-collapse__body {
    margin-top: 0;
  }

  .collapse-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.collapse-content {
  max-height: 270px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 0.25rem;
  }

  &::-webkit-scrollbar-thumb {
    background-color: gray;
    border-radius: 20px;
  } 
}
</style>
